export enum ManualStatusEdition {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
